import axios from "axios";

class ApiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || "https://ame.beeleads.com.br/";
    
    this.defaultAxios = axios.create({
      baseURL: this.baseUrl,
    });

    // this.user = {};
    this.defaultAxios.interceptors.response.use(
      (response) => response,
      (error) => {
        // if (error && error.response.status === 401) {
        //   window.location.replace("/");
        // } else if (error.response.status === 406) {
        //   return error;
        // }
        return Promise.reject(error);
      }
    );
  }

  async get(suffix, params) {
    return await this.defaultAxios.get(suffix, { params });
  }

  async post(suffix, params) {
    return await this.defaultAxios.post(suffix, params,
      { headers: { //iOS 12 bug fix. Add Content-type in headers to post method
        "Content-Type": "text/plain"
      }
    });
  }

  async delete(suffix, params) {
    return await this.defaultAxios.delete(suffix, params);
  }

  async patch(suffix, params) {
    return await this.defaultAxios.patch(suffix, params);
  }
}

export default new ApiService();
